import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { parseUnconfirmedProducts } from './Hooks/hook/upgradeOrder';

/**
 * Cảnh báo khi server báo KT đổi/thêm sản phẩm mà bộ phận tạo đơn chưa xác nhận.
 * KT bấm "Gửi yêu cầu cập nhật" mới gọi onOk (YeuCauChinhSua), "Để sau" thì giữ nguyên để sửa lại sản phẩm.
 * @param source message lỗi server (tự tách tên SP) hoặc danh sách tên SP có sẵn
 */
export const confirmRequestUpdate = (source: string | string[], onOk: () => Promise<void>) => {
  const serverMsg = Array.isArray(source) ? '' : source;
  const names = Array.isArray(source) ? source : parseUnconfirmedProducts(source);
  // gộp tên trùng (mỗi thiết bị một dòng) -> "TMS-4G02 (x2)"
  const counts = names.reduce<Record<string, number>>((acc, name) => {
    acc[name] = (acc[name] || 0) + 1;
    return acc;
  }, {});
  const products = Object.entries(counts).map(([name, qty]) => (qty > 1 ? `${name} (x${qty})` : name));

  Modal.confirm({
    className: 'p-4',
    width: 650,
    icon: (
      <ExclamationCircleFilled
        style={{ color: '#faad14', fontSize: 22, verticalAlign: 'middle', position: 'relative', top: 5 }}
      />
    ),
    title: 'Sản phẩm chưa được xác nhận',
    content: (
      <div className="flex flex-col gap-2">
        {products.length > 0 ? (
          <>
            <div>Các sản phẩm sau chưa được bộ phận tạo đơn xác nhận:</div>
            <ul className="list-disc pl-5 font-semibold text-gray-700 max-h-48 overflow-auto">
              {products.map((name, i) => (
                <li key={i}>{name}</li>
              ))}
            </ul>
          </>
        ) : (
          <div>{serverMsg}</div>
        )}
        <div className="rounded border border-yellow-300 bg-yellow-50 px-2 py-1.5 text-[13px] text-yellow-800">
          Khi gửi yêu cầu cập nhật đơn cho người tạo đơn, thời gian thực hiện đơn của kỹ thuật vẫn tiếp tục đếm và không
          thể nhấn <b>Hoàn tất đơn</b> cho đến khi người tạo đơn xác nhận.
        </div>
      </div>
    ),
    okText: 'Gửi yêu cầu cập nhật',
    cancelText: 'Đóng',
    onOk
  });
};
